<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-tooltip
        bottom
        open-delay="250"
    >
        <template v-slot:activator="{ on }">
            <div>
                <v-menu
                    v-model="menu_open"
                    :attach="'#task_' + getTaskId(task) + '_snooze-menu'"
                    content-class="overflow-y-hidden dropmenu pa-1 elevation-0"
                    left
                    :top="openTowardsTop"
                    nudge-right="50"
                    offset-y
                    :transition="null"
                >
                    <template v-slot:activator="{ on: show }">
                        <div :id="'task_' + getTaskId(task) + '_snooze-menu'">
                            <icon-button
                                :on="{ ...show, ...on }"
                                :icon-size="iconSize"
                                icon="CalendarClock"
                            />
                        </div>
                    </template>
                    <v-card class="date-range">
                        <v-row
                            no-gutters
                            justify="start"
                            align="start"
                        >
                            <v-col style="min-width: 242px">
                                <v-card-title class="ma-0 pt-4 pb-0 px-4">
                                    <span class="title"> {{ $t("Snooze until...") }}</span>
                                </v-card-title>
                                <template>
                                    <v-list class="pt-4 pb-3">
                                        <v-list-item
                                            v-for="(mitem, index) in filtered_snooze_menu"
                                            :key="index"
                                            class="menu-list-item"
                                            dense
                                            @click.stop="mitem.action()"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title class="body-2">
                                                    {{ mitem.title }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <span class="g5--text body-2">
                                                    {{ mitem.date }}
                                                </span>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item
                                            v-if="last_snooze_date"
                                            class="menu-list-item"
                                            dense
                                            @click.stop="saveSnoozeDateTime(last_snooze_date)"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title class="body-2">
                                                    {{ $t("Last") }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <span class="g5--text body-2">
                                                    {{ formatDateTimeFriendly(last_snooze_date) }}
                                                </span>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>

                                    <v-list-item
                                        class="py-1"
                                        dense
                                        style="border-top: 1px solid var(--v-g3-base)"
                                        @click.stop="onSnoozeCustomClick"
                                    >
                                        <v-list-item-icon class="mr-4">
                                            <icon icon="CalendarDays" color="n3" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="body-2">
                                                {{ $t("Pick date & time") }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-menu>
            </div>
        </template>
        <span>{{ $t("Snooze") }}</span>
    </v-tooltip>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import TaskModule from "../../store/modules/task";
import DialogModule from "../../store/modules/dialog";
import { $t } from "@/i18n";
import { actions as dialogActions } from "../../store/modules/dialog";
import { formatWeekdayShort, calcDateEquals, parseSysDateTime, formatTime } from "../../plugins/formatting";
import { updateListState } from "../../store/store_helpers";

export default {
    name: "TaskSnoozeMenu",
    props: {
        task: {
            type: Object,
            required: true
        },
        openTowardsTop: {
            type: Boolean,
            required: false
        },
        inTaskForm: {
            type: Boolean,
            default: false
        },
        btnClass: {
            type: String,
            required: false,
            default: ""
        },
        iconSize: {
            type: Number,
            default: null
        }
    },
    setup(props, ctx) {
        const now = new Date();
        const dialogModule = DialogModule();
        const { saveTaskField, last_snooze_date, getTaskId, getTaskIdKey, tasks_list } = TaskModule();
        const custom_date = ref();
        const custom_time = ref();
        const custom_date_mode = ref(false);
        const custom_date_picker = ref(false);
        const menu_open = ref(false);

        const formatDateTimeFriendly = function(d) {
            if (!d) return "";
            if (typeof d == "string") d = parseSysDateTime(d);

            if (calcDateEquals(now, d, "date")) {
                return formatTime(d);
            } else {
                return formatWeekdayShort(d) + ", " + formatTime(d);
            }
        };
        const tomorrow = () => {
            let s = new Date();
            s = s.calcAddDays(1);
            s.setHours(8, 0, 0);
            return s;
        };
        const later_this_week = () => {
            let s = new Date();
            let day = s.getDay() === 0 ? 6 : s.getDay() - 1;
            if ([0, 1, 2].includes(day)) {
                s = s.calcAddDays(3 - day); // thursday
                s.setHours(8, 0, 0);
                return s;
            } else if (day === 3) {
                s = s.calcAddDays(4 - day); // friday
                s.setHours(8, 0, 0);
                return s;
            }
            return null;
        };
        const next_week = () => {
            let s = now;
            s = s.calcWeekStart().calcDateAdd(1, "week");
            s.setHours(8, 0, 0);
            return s;
        };

        const saveSnoozeDateTime = function(date) {
            if (typeof date === "string") date = parseSysDateTime(date);

            last_snooze_date.value = date.formatSysDateTime();

            let due_date = parseSysDateTime(props.task.due_date);

            if (due_date >= date || props.task.has_due_date === 0) {
                postponeTask(date, props.task.has_due_date === 0);
            } else {
                let dialog_props = {
                    title: $t("Do you also want to postpone the due date?"),
                    confirm_text: $t("Yes"),
                    cancel_text: $t("Cancel"),
                    action: function() {
                        postponeTask(date, true);
                    }
                };
                dialogModule.setConfirmOptions(dialog_props);
                dialogModule.openConfirmDialog();
            }
        };
        const postponeTask = function(new_date, chn_due_date) {
            let new_datetime = "{0} {1}".format(new_date.formatSysDate(), props.task.date.split(" ")[1]);
            let new_due_datetime = props.task.due_date;

            if (chn_due_date) {
                new_due_datetime = "{0} {1}".format(new_date.formatSysDate(), props.task.due_date.split(" ")[1]);
            }

            let data = {
                id: props.task.id,
                virtual_id: props.task.virtual_id,
                date: new_datetime,
                due_date: new_due_datetime
            };

            saveTaskField(data, "TaskSnoozeMenu.vue").catch(ex => errorDialog.showError(ex));
        };
        const snooze_menu = ref([
            // 0 = Monday
            // 6 = Sunday
            {
                title: $t("Tomorrow"),
                type: "tomorrow",
                date: formatDateTimeFriendly(tomorrow()),
                action: () => saveSnoozeDateTime(tomorrow()),
                displayDays: [0,1,2,3,4,5,6]
            },
            {
                title: $t("Later this week"),
                type: "later_this_week",
                date: formatDateTimeFriendly(later_this_week()),
                action: () => saveSnoozeDateTime(later_this_week()),
                displayDays: [0,1,2,3]
            },
            {
                title: $t("Next week"),
                type: "next_week",
                date: formatDateTimeFriendly(next_week()),
                action: () => saveSnoozeDateTime(next_week()),
                displayDays: [0,1,2,3,4,5,6]
            }
        ]);
        const filtered_snooze_menu = computed(function() {
            return snooze_menu.value.filter(function(m) {
                let day = now.getDay() === 0 ? 6 : now.getDay() - 1
                return m['displayDays'].includes(day)
            });
        });

        const onSnoozeCustomClick = () => {
            if (props.inTaskForm && !props.task.project_id) {
                ctx.emit("openDatePicker");
                menu_open.value = false;
            } else {
                dialogActions.setDialogOptions({
                    component: () => import("@/views/Dialog/DateAndTimeDialog"),
                    width: 358,
                    payload: {},
                    action: saveSnoozeDateTime,
                });
                dialogActions.openDialog();
            }
        };
        const onDateFieldClick = () => {
            custom_date_picker.value = true;
        };
        return {
            last_snooze_date,
            snooze_menu,
            onSnoozeCustomClick,
            custom_date_mode,
            custom_date,
            custom_time,
            custom_date_picker,
            onDateFieldClick,
            formatDateTimeFriendly,
            saveSnoozeDateTime,
            filtered_snooze_menu,
            getTaskId,
            menu_open
        };
    }
};
</script>
